import template from "./library-tariffs-csv-modal.html";

const ImportTariffsCsvModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class ImportTariffsCsvModalController {
    /* @ngInject */
    constructor($rootScope, $window, $filter, Notification, Tariff, Utils) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.$window = $window;
      this.NotificationService = Notification;
      this.Tariff = Tariff;
      this.Utils = Utils;
    }

    $onInit() {
      this.tariffsFile = null;
    }

    downloadTariffsTemplate() {
      this.$window.open(
        `${process.env.CLIENT_URL}/resources/quoters-tariffs-template.csv`,
        "_blank"
      );
    }

    async importCsv() {
      try {
        this.errors = null;
        this.saving = true;
        const formData = new FormData();
        formData.append("csvFile", this.tariffsFile);
        await this.Tariff.importCsv(formData);

        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.tariffsImported"
          ),
        });
      } catch (error) {
        if (error.status === 400 && error.data.csv) {
          this.NotificationService.error({
            title: this.$filter("trans")(
              "notificationService.title.csvImportError"
            ),
          });
          const organization = this.$rootScope.organization;
          this.Utils.downloadCsv(
            error.data.csv,
            `ERROR-IMPORTING-${organization.name}-rates-${new Date()
              .toJSON()
              .slice(0, 10)}.csv`
          );
        } else {
          this.NotificationService.error({
            title: this.$filter("trans")("notificationService.title.ups"),
          });
        }
      } finally {
        this.tariffsFile = null;
        this.saving = false;
        this.close({ $value: false });
        this.$rootScope.$applyAsync();
      }
    }
  },
};

export default ImportTariffsCsvModalComponent;
